import { Facebook, Instagram, Music2 } from "lucide-react";
import { QUOTE_URL, SOCIALS, BUSINESS_NAME } from "@/lib/constants";
import { useSiteContent } from "@/lib/content";

export default function Header() {
  const content = useSiteContent();
  const socials = content?.socials || SOCIALS;
  return (
    <header
      data-testid="site-header"
      className="fixed top-0 inset-x-0 z-50 border-b border-gold/30 bg-white/85 backdrop-blur-xl"
    >
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-3 sm:px-8">
        <a href="#top" className="flex items-center gap-3" data-testid="header-brand-link">
          <img
            src="/brand/logo.png"
            alt="Miss Cupcake Creations logo"
            className="h-11 w-11 rounded-full ring-1 ring-gold/50 shadow-sm"
          />
          <span className="hidden sm:block font-serif text-xl font-semibold tracking-tight text-burgundy leading-none">
            {BUSINESS_NAME}
            <span className="block font-script text-sm font-medium text-gold">Celebrate it uniquely</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-7 text-sm font-medium text-wine" data-testid="header-nav">
          <a href="#gallery" className="hover:text-gold transition-colors" data-testid="nav-gallery-link">Gallery</a>
          <a href="/prices" className="hover:text-gold transition-colors" data-testid="nav-prices-link">Prices</a>
          <a href="/servings-guide" className="hover:text-gold transition-colors" data-testid="nav-guide-link">Size Guide</a>
          <a href="#about" className="hover:text-gold transition-colors" data-testid="nav-about-link">About</a>
          <a href="#contact" className="hover:text-gold transition-colors" data-testid="nav-contact-link">Contact</a>
        </nav>

        <div className="flex items-center gap-3">
          <div className="hidden lg:flex items-center gap-3 text-burgundy/70">
            <a href={socials.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook" data-testid="header-facebook-link" className="hover:text-gold transition-colors">
              <Facebook className="h-4 w-4" />
            </a>
            <a href={socials.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid="header-instagram-link" className="hover:text-gold transition-colors">
              <Instagram className="h-4 w-4" />
            </a>
            <a href={socials.tiktok} target="_blank" rel="noopener noreferrer" aria-label="TikTok" data-testid="header-tiktok-link" className="hover:text-gold transition-colors">
              <Music2 className="h-4 w-4" />
            </a>
          </div>
          <a
            href={QUOTE_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-quote-button"
            className="rounded-full border border-gold bg-gold px-4 py-2 text-xs sm:text-sm font-semibold text-white shadow-[0_8px_24px_-8px_rgba(201,162,39,0.7)] transition-all duration-300 hover:-translate-y-0.5 hover:bg-golddeep"
          >
            Request a Quote
          </a>
        </div>
      </div>
    </header>
  );
}
